import * as types from './actionTypes'

export const getApplications = (apps, logo) => ({
    type: types.APPLICATIONS_GET,
    apps,
    logo
})

export const changeApplication = (application) => ({
    type: types.CHANGE_APPLICATION_FETCH,
    application
})

export const changeApplicationSuccess = (apps, logo) => ({
    type: types.CHANGE_APPLICATION_SUCCESS,
	apps,
	logo
})

export const changeApplicationFailed = () => ({
    type: types.CHANGE_APPLICATION_FAILED
})

export const setApplicationLogo = (img) => ({
    type: types.SET_APPLICATION_LOGO,
    img
})

export const setApplicationLogoSuccess = (logo) => ({
    type: types.SET_APPLICATION_LOGO_SUCCESS,
    logo
})

export const setApplicationLogoFailed = () => ({
    type: types.SET_APPLICATION_LOGO_FAILED
})

export const fetchCallUsers = () => ({
    type: types.CALL_USERS_FETCH
})

export const fetchCallUsersSuccess = (contacts) => ({
    type: types.CALL_USERS_SUCCESS,
    contacts
})

export const fetchCallUsersFailed = () => ({
    type: types.CALL_USERS_FAILED
})

export const fetchPublicEnabled = () => ({
    type: types.PUBLIC_ACCESS_FETCH
})

export const fetchPublicEnabledSuccess = (data) => ({
    type: types.PUBLIC_ACCESS_SUCCESS,
    data
})

export const fetchPublicEnabledFailed = () => ({
    type: types.PUBLIC_ACCESS_FAILED
})

export const createSender = (sender, service) => ({
    type: types.SENDER_CREATE,
    sender,
    service
})

export const createSenderSuccess = (data) => ({
    type: types.SENDER_CREATE_SUCCESS,
    data
})

export const createSenderFailed = (error) => ({
    type: types.SENDER_CREATE_FAILED,
    error
})

export const deleteSender = (id) => ({
    type: types.SENDER_DELETE,
    id
})

export const deleteSenderSuccess = () => ({
    type: types.SENDER_DELETE_SUCCESS
})

export const deleteSenderFailed = () => ({
    type: types.SENDER_DELETE_FAILED
})

export const verifySender = (id) => ({
    type: types.SENDER_VERIFY,
    id
})

export const verifySenderSuccess = () => ({
    type: types.SENDER_VERIFY_SUCCESS
})

export const verifySenderFailed = () => ({
    type: types.SENDER_VERIFY_FAILED
})

export const fetchUsers = () => ({
    type: types.USERS_FETCH
})

export const fetchUsersSuccess = (users) => ({
    type: types.USERS_FETCH_SUCCESS,
    users
})

export const fetchUsersFailed = () => ({
    type: types.USERS_FETCH_FAILED
})

export const updateUser = (obj) => ({
    type: types.USER_UPDATE,
    obj
})

export const updateUserSuccess = (user) => ({
    type: types.USER_UPDATE_SUCCESS,
    user
})

export const updateUserFailed = () => ({
    type: types.USER_UPDATE_FAILED
})

export const deleteUser = (name) => ({
    type: types.USER_DELETE,
    name
})

export const deleteUserSuccess = (user) => ({
    type: types.USER_DELETE_SUCCESS,
    user
})

export const deleteUserFailed = () => ({
    type: types.USER_DELETE_FAILED
})

export const setApplicationName = (name) => ({
    type: types.SET_APPLICATION_NAME,
    name
})

export const setApplicationNameSuccess = () => ({
    type: types.SET_APPLICATION_NAME_SUCCESS
})

export const setApplicationNameFailed = () => ({
    type: types.SET_APPLICATION_NAME_FAILED
})

export const setOwner = (name) => ({
    type: types.SET_OWNER,
    name
})

export const setOwnerSuccess = (users) => ({
    type: types.SET_OWNER_SUCCESS,
    users
})

export const setOwnerFailed = () => ({
    type: types.SET_OWNER_FAILED
})
